import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-myfooter',
  templateUrl: './myfooter.component.html',
  styleUrls: ['./myfooter.component.scss']
})
export class MyfooterComponent implements OnInit {

  currentYear: number = new Date().getFullYear();
  constructor() { }

  ngOnInit() {
  }

}
